import { get, isNaN, isNull, isUndefined } from 'lodash'
import NumberFormatter from '../filters/number'

export default {
  data() {
    return {
      cursorPosition: 0,
      separatorCount: 0,
      blurState: true,
    }
  },
  computed: {
    minValue() {
      return this.field.minValue
    },
    maxValue() {
      return this.field.maxValue
    },
    computedReadOnly() {
      return Boolean(this.readOnly || this.groupReadOnly)
    },
    formattedValue: {
      get() {
        return this.getFormattedValue()
      },
      set(value) {
        this.setValue(value)
      },
    },
    storedValue: {
      get() {
        return this.getStoredValue()
      },
      set(value) {
        return value
      },
    },
    maxLength() {
      return get(this.field, 'formats.maxlength')
    },
    decimals() {
      return parseInt(get(this.field, 'formats.decimal', '0'))
    },
    thousandSeparated() {
      return get(this.field, 'formats.thousandSeparated', true)
    },
    suffix() {
      return get(this.field, 'formats.suffix', '')
    },
    prefix() {
      return get(this.field, 'formats.prefix', '')
    },
  },
  methods: {
    isValidValue(value) {
      return !isUndefined(value) && !isNull(value) && !isNaN(value)
    },
    getParsedValue(value) {
      const parsedValue = NumberFormatter.parseFormatted(value)
      return this.isValidValue(parsedValue) ? parsedValue : ''
    },
    getFormattedValue() {
      if (this.blurState && this.thousandSeparated && this.isValidValue(this.storedValue)) {
        const stringValue = this.storedValue === '-' ? '0' : this.storedValue.toString()
        return NumberFormatter.formatNumberDecimal(stringValue, this.decimals)
      }
      return this.storedValue
    },
    getStoredValue() {
      if (this.blurState && this.thousandSeparated && this.isValidValue(this.value)) {
        const stringValue = this.value === '-' ? '0' : this.value.toString()
        return NumberFormatter.formatNumberDecimal(stringValue, this.decimals)
      }
      return this.value
    },
    getCountOfSeparator(value) {
      return value.match(NumberFormatter.DECIMAL_SEPARATOR_RE).length
    },
    handleDecimalSeparator($event) {
      const value = $event.target.value
      const key = $event.key

      if (this.isLocalSeparator(key)) {
        const countOfSeparator = this.getCountOfSeparator(value)
        const isFirstCharacter = value.length === 1

        if (countOfSeparator > 1 || isFirstCharacter) {
          $event.target.value = value.slice(0, -1)
        }
      } else {
        $event.target.value = value.slice(0, -1)
      }

      $event.preventDefault()
    },
    handleMinusSign($event) {
      const value = $event.target.value

      if (value.length !== 1) {
        $event.target.value = value.slice(0, -1)
      }

      $event.preventDefault()
    },
    isDecimalSeparator(key) {
      return NumberFormatter.DECIMAL_SEPARATORS_RE.test(key)
    },
    isMinusSign(key) {
      return NumberFormatter.NEGATIVE_RE.test(key)
    },
    isNonDigitCharacter(key) {
      return NumberFormatter.NOT_NUMBER_OR_DECIMALS_RE.test(key)
    },
    isLocalSeparator(key) {
      return NumberFormatter.DECIMAL_SEPARATOR_RE.test(key)
    },
    handleNonDigitCharacter($event) {
      $event.target.value = $event.target.value.slice(0, -1)
      $event.preventDefault()
    },
    isNotValidValue(value) {
      return !value || NumberFormatter.NAN_RE.test(value)
    },
    handleNotValidValue($event) {
      $event.target.value = ''
      $event.preventDefault()
      this.formattedValue = ''
    },
    onFocus() {
      this.blurState = false
    },
    onBlur($event) {
      this.blurState = true
      const value = $event.target.value === '-' ? '0' : $event.target.value
      const key = value.slice(-1)

      if (this.isNotValidValue(value)) {
        return this.handleNotValidValue($event)
      }

      if (this.isNonDigitCharacter(key)) {
        return this.handleNonDigitCharacter($event)
      }

      if (this.isDecimalSeparator(key)) {
        return this.handleDecimalSeparator($event)
      }

      if (this.isMinusSign(key)) {
        return this.handleMinusSign($event)
      }

      this.formattedValue = value
    },
  },
}
